import { Package } from 'lucide-react';
import { mediaUrl } from '@/utils/mediaUrl';
import { useLightboxStore } from '@store/uiStore';
import { formatCurrency } from '@utils/formatters';
import type { Product } from '@/types';

interface ProductCardProps {
  product: Product;
  onAdd?: (product: Product) => void;
  showWholesaler?: boolean;
}

export function ProductCard({ product, onAdd, showWholesaler }: ProductCardProps) {
  const openLightbox = useLightboxStore((s) => s.openLightbox);
  const image = mediaUrl(product.image);

  return (
    <article className="card-elevated group overflow-hidden hover:-translate-y-0.5">
      <div className="aspect-square bg-slate-50">
        {image ? (
          <button type="button" className="h-full w-full" onClick={() => openLightbox(image, product.name)}>
            <img
              src={image}
              alt={product.name}
              className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
            />
          </button>
        ) : (
          <div className="flex h-full items-center justify-center text-slate-300">
            <Package className="h-12 w-12" strokeWidth={1.25} />
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="truncate font-semibold text-slate-900">{product.name}</h3>
        {showWholesaler && product.wholesaler && (
          <p className="mt-1 truncate text-xs font-medium uppercase tracking-wide text-slate-500">
            {product.wholesaler.name}
          </p>
        )}
        <div className="mt-3 flex items-end justify-between gap-2">
          <div>
            <p className="text-lg font-bold text-slate-900">{formatCurrency(Number(product.price))}</p>
            <p className="text-xs text-slate-500">/{product.unit}</p>
          </div>
          {onAdd && (
            <button
              type="button"
              onClick={() => onAdd(product)}
              className="rounded-lg bg-brand-500 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-brand-600"
            >
              Sepete
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
